import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_save_btn = _resolveComponent("save-btn")!
  const _component_escalate_btn = _resolveComponent("escalate-btn")!
  const _component_resolve_btn = _resolveComponent("resolve-btn")!
  const _component_restore_btn = _resolveComponent("restore-btn")!
  const _component_move_to_timeline_btn = _resolveComponent("move-to-timeline-btn")!
  const _component_remove_from_timeline_btn = _resolveComponent("remove-from-timeline-btn")!
  const _component_q_btn_group = _resolveComponent("q-btn-group")!

  return (_ctx.isGranted('VIEW_POST_ACTIONS'))
    ? (_openBlock(), _createBlock(_component_q_btn_group, {
        key: 0,
        spread: "",
        class: "full-width"
      }, {
        default: _withCtx(() => [
          (_ctx.showSave)
            ? (_openBlock(), _createBlock(_component_save_btn, {
                key: 0,
                "post-id": _ctx.post.id
              }, null, 8, ["post-id"]))
            : _createCommentVNode("", true),
          (_ctx.showEscalate)
            ? (_openBlock(), _createBlock(_component_escalate_btn, {
                key: 1,
                post: _ctx.post
              }, null, 8, ["post"]))
            : _createCommentVNode("", true),
          (_ctx.showResolve)
            ? (_openBlock(), _createBlock(_component_resolve_btn, {
                key: 2,
                "post-id": _ctx.post.id
              }, null, 8, ["post-id"]))
            : _createCommentVNode("", true),
          (_ctx.showResolveAndTimeline)
            ? (_openBlock(), _createBlock(_component_resolve_btn, {
                key: 3,
                "post-id": _ctx.post.id,
                "move-to-timeline": ""
              }, null, 8, ["post-id"]))
            : _createCommentVNode("", true),
          (_ctx.showRestore)
            ? (_openBlock(), _createBlock(_component_restore_btn, {
                key: 4,
                "post-id": _ctx.post.id,
                class: "full-width"
              }, null, 8, ["post-id"]))
            : _createCommentVNode("", true),
          (_ctx.showMoveToTimeline)
            ? (_openBlock(), _createBlock(_component_move_to_timeline_btn, {
                key: 5,
                "post-id": _ctx.post.id
              }, null, 8, ["post-id"]))
            : _createCommentVNode("", true),
          (_ctx.showRemoveFromTimeline)
            ? (_openBlock(), _createBlock(_component_remove_from_timeline_btn, {
                key: 6,
                "post-id": _ctx.post.id
              }, null, 8, ["post-id"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}